import * as kenoTranslationsPackage from '@nsftx/i18n-keno';

export default {
  name: 'keno',
  rules: {},
  paytable: null,
  translationPackage: kenoTranslationsPackage,
};
